import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/forms';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3 from 'primeng/inputnumber';
import * as i4 from 'primeng/dropdown';
import { PrimengLibraryModule } from 'primeng-library';

class SelectCurrencyService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getCurrencyCode() {
        var encryptedText = this.toEncrypt('FB_HIRING_CURRENCY');
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
SelectCurrencyService.ɵfac = function SelectCurrencyService_Factory(t) { return new (t || SelectCurrencyService)(i0.ɵɵinject(i1.HttpClient)); };
SelectCurrencyService.ɵprov = i0.ɵɵdefineInjectable({ token: SelectCurrencyService, factory: SelectCurrencyService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectCurrencyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class SelectCurrencyComponent {
    constructor(selectCurrencyService) {
        this.selectCurrencyService = selectCurrencyService;
        this.observableSubscription$ = new Subject();
        this.getCurrencyData = [];
        this.group = new FormGroup({});
    }
    ngOnInit() {
        this.group.addControl(this.inputParams.name, new FormGroup({
            currency: new FormControl(null)
        }));
        this.currencyForm = (this.group.controls[this.inputParams.name]);
        this.getCurrencyDetails();
    }
    getCurrencyDetails() {
        this.selectCurrencyService.getCurrencyCode().pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            this.getCurrencyData = (response === null || response === void 0 ? void 0 : response.data) || null;
        });
    }
    currencyChange(data) {
        this.currencyForm.controls["currency"].setValue(data.value);
        let type = this.getCurrencyData.filter((x) => x.id == data.value);
        this.group.controls[this.inputParams.name].patchValue({
            currencyType: type,
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
SelectCurrencyComponent.ɵfac = function SelectCurrencyComponent_Factory(t) { return new (t || SelectCurrencyComponent)(i0.ɵɵdirectiveInject(SelectCurrencyService)); };
SelectCurrencyComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SelectCurrencyComponent, selectors: [["select-currency"]], inputs: { inputParams: "inputParams", group: "group", formControlName: "formControlName" }, decls: 5, vars: 2, consts: [[1, "container-fluid", "custom-period-selection", 3, "formGroup"], [1, "row"], [1, "col-12", "pl-0", "mt-2"], ["inputId", "integeronly", "formControlName", "payRate", "placeholder", "Enter Pay Rate", 1, "payrate"], ["appendTo", "body", "name", "currency", "placeholder", "Currency", "formControlName", "currency", "optionLabel", "name", "optionValue", "id", 1, "currency", 3, "options", "onChange"]], template: function SelectCurrencyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "p-inputNumber", 3);
        i0.ɵɵelementStart(4, "p-dropdown", 4);
        i0.ɵɵlistener("onChange", function SelectCurrencyComponent_Template_p_dropdown_onChange_4_listener($event) { return ctx.currencyChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.currencyForm);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.getCurrencyData);
    } }, directives: [i2.NgControlStatusGroup, i2.FormGroupDirective, i3.InputNumber, i2.NgControlStatus, i2.FormControlName, i4.Dropdown], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectCurrencyComponent, [{
        type: Component,
        args: [{
                selector: 'select-currency',
                templateUrl: "select-currency.component.html",
                styleUrls: ["select-currency.component.scss"],
            }]
    }], function () { return [{ type: SelectCurrencyService }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class SelectCurrencyModule {
}
SelectCurrencyModule.ɵfac = function SelectCurrencyModule_Factory(t) { return new (t || SelectCurrencyModule)(); };
SelectCurrencyModule.ɵmod = i0.ɵɵdefineNgModule({ type: SelectCurrencyModule });
SelectCurrencyModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SelectCurrencyModule, { declarations: [SelectCurrencyComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule], exports: [SelectCurrencyComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectCurrencyModule, [{
        type: NgModule,
        args: [{
                declarations: [SelectCurrencyComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [SelectCurrencyComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of select-currency
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SelectCurrencyComponent, SelectCurrencyModule, SelectCurrencyService };
//# sourceMappingURL=select-currency.js.map
